import { parse } from "cookie";

export const state = () => ({
    counter: 0,
});

export const mutations = {
    increment(state) {
        state.counter++;
    },
};

export const actions = {
    nuxtServerInit({ commit }, { req }) {
        let serverCookies = parse(req.headers.cookie || "") || {};
        commit("handbook/setLightMode", !!serverCookies["light-mode"]);
    },
};
